import React from 'react';

import DataItemView from '../../../common/view/DataItemView';
import ModifiedFlag from '../../../common/controls/ModifiedFlag';
import ErrorFlag from '../../../common/controls/ErrorFlag';

import MetadataEditor from '../../../common/metadata/MetadataEditor';

export default class ParametersView extends DataItemView {
  static displayName = ParametersView.name;

  constructor(props) {
    super(props);

    this.onEditorValueListener = this.onEditorValueChanged.bind(this);
    this.bindDataItem(props.parameters);
  }

  componentDidUpdate() {
    this.bindDataItem(this.props.parameters);
  }

  render() {
    if (!this.state.isDataBound)
      return (<div />);

    return (
      <table><tbody>
      {
        this.dataItem.propertyNames.map(propertyName =>
        (
          <tr className="pwx-field" key={propertyName}>
            <td className="pwx-field-label">{this.state[propertyName + '_displayName']}:</td>
            <td className="pwx-field-spacer" />
            <td className="pwx-field-value">
              <MetadataEditor
                height="30px"
                name={propertyName}
                value={this.state[propertyName]}
                metadataRule={this.state[propertyName + '_metadataRule']}
                onValueChanged={this.onEditorValueListener}
                width="200px"
              />
            </td>
            <td>
              <ModifiedFlag isModifiedProperty={this.state[propertyName + '_isModified']} />
              <ErrorFlag errorProperty={this.state[propertyName + '_error']} />
            </td>
          </tr>
        ))
      }
      </tbody></table>
    );
  }

  onEditorValueChanged(propertyName, value) {
    if (this.dataItem !== null)
      this.dataItem.updateProperty(propertyName, value);
  }
}